var _path, _circle, _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicLinkWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.894 41.387a4.893 4.893 0 10-7.647 4.044v10.637h5.505V45.43a4.888 4.888 0 002.142-4.044z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#DC3232"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.389,
    cy: 81.893,
    rx: 18,
    ry: 7,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#magic-link-warning_svg__clip0_27294_108341)",
    stroke: "#fff",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.633 36.833c5.983 0 10.833-4.85 10.833-10.833 0-5.983-4.85-10.833-10.833-10.833-5.983 0-10.834 4.85-10.834 10.833 0 5.983 4.85 10.833 10.834 10.833zM26.633 30.333h.01M26.633 21.667V26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "magic-link-warning_svg__clip0_27294_108341"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.633 13)",
    d: "M0 0h26v26H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/magic-link-warning.c400e571.svg";
export { SvgMagicLinkWarning as ReactComponent };